/**
 * ObjectNamingSystem - generates deterministic names for objects during runtime.
 */

import { ClassRegistry } from './ClassRegistry.js';

export class ObjectNamingSystem {
  private static counters: Map<string, number> = new Map();

  /** Generates a unique name for an object */
  public static generateName(object: any): string {
    const className = ClassRegistry.getClassOrConstructorName(object);
    const counter = this.counters.get(className) ?? 0;
    this.counters.set(className, counter + 1);
    return `${className}_${counter}`;
  }
}
